export default "__VITE_ASSET__Cv_1GwoA__"